export class AddAdditionalEmailToUserSuccess {
    static readonly type = '[User] AddAdditionalEmailToUserSuccess';
}
